exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @file\n * @auth jinguangguo\n * @date 2017/1/9\n */\n.comp-toast {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 64px;\n  line-height: 64px;\n  z-index: 100;\n  transition: all 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  transform: translateY(-100%);\n  opacity: 0.98; }\n  .comp-toast--warning {\n    background-color: #f9c991; }\n  .comp-toast--success {\n    background-color: #61d6b4; }\n  .comp-toast--error {\n    background-color: #f57d77; }\n  .comp-toast .toast-wrapper {\n    position: relative;\n    width: 1184px;\n    margin: 0 auto;\n    text-align: center;\n    color: #fff;\n    font-size: 16px; }\n    .comp-toast .toast-wrapper .close {\n      position: absolute;\n      right: 0;\n      top: 18px;\n      line-height: 1;\n      cursor: pointer; }\n      .comp-toast .toast-wrapper .close .icon-close {\n        font-size: 26px; }\n  .comp-toast.slide-fade-enter-active {\n    display: block;\n    transform: translateY(0); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./~/sass-loader!./src/component/Toast/Toast.scss
// module id = 8
// module chunks = 0 1